{
  "termsInfo": "<strong>Uppdatering av Användarvillkor.</strong> Se uppdateringarna <2>här</2>.",
  "privacyInfo": "<strong>Uppdatering av Integritetspolicy.</strong> Se uppdateringarna <2>här</2>."
}
